import { getUser } from "../services/Auth";
import api from "./api";

export const BuscarEntregadorPorNomeOuCpf = async (busca) => {
  try {
    const entregadores = await api.get(`/buscar/entregadores/${busca}`);
    return entregadores.data;
  } catch (error) {
    throw error;
  }
};

export const BuscarPedidoPorCodigo = async (codigo) => {
  try {
    const usuario = await getUser();
    const pd = await api.get(
      `/buscar/estabelecimento/${usuario.estabelecimento._id}/pedidos/${codigo}`,
    );
    return pd.data;
  } catch (error) {
    throw error;
  }
};

export const BuscarProdutoPorNomeOuSku = async (busca) => {
  try {
    const usuario = await getUser();
    const produtos = await api.get(
      `/buscar/estabelecimento/${usuario.estabelecimento._id}/produtos/${busca}`,
    );
    return produtos.data;
  } catch (error) {
    throw error;
  }
};

export const BuscarSeparadorPorNomeOuCpf = async (busca) => {
  try {
    const usuario = await getUser();
    const separadores = await api.get(
      `/buscar/estabelecimento/${usuario.estabelecimento._id}/separadores/${busca}`,
    );
    return separadores.data;
  } catch (error) {
    throw error;
  }
};
